import { render } from "./Proscan.vue?vue&type=template&id=705700da&scoped=true"
import script from "./Proscan.vue?vue&type=script&lang=js"
export * from "./Proscan.vue?vue&type=script&lang=js"

import "./Proscan.vue?vue&type=style&index=0&id=705700da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705700da"]])

export default __exports__